import { render, staticRenderFns } from "./Frage_4.vue?vue&type=template&id=5119ea41&"
import script from "./Frage_4.vue?vue&type=script&lang=js&"
export * from "./Frage_4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports